import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  contentBox: {
    width: '100%',
  },

  itemBox: {
    '& span': {
      margin: '0.25rem !important',
    },
  },

  colorBox: {
    width: '100%',
    height: '200px',
    marginBottom: '0.25rem',
    borderRadius: '0.75rem',
  },

  logoBox: {
    width: '100%',
    height: '250px',
    backgroundColor: `#FAFAFA`,
    userSelect: 'none',
    border: '1px solid #000000',
    borderRadius: '0.75rem',
    padding: '2.5rem',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },

  logoBoxBlack: {
    width: '100%',
    height: '250px',
    backgroundColor: '#000000',
    userSelect: 'none',
    border: '1px solid #000000',
    borderRadius: '0.75rem',
    padding: '2.5rem',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },
}))

export { useStyles }
